import { defineNuxtPlugin } from '#app/nuxt'
import { LazyLazyYoutube, LazyLazyVimeo } from '#components'
const lazyGlobalComponents = [
  ["LazyYoutube", LazyLazyYoutube],
["LazyVimeo", LazyLazyVimeo],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
